import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AppState } from "../../../store";
import React, { useEffect } from "react";
import {
  clearFilterProvisions,
  filterProvisions,
} from "../../agency/store/filter-provision.slice";
import { fetchAllProvisions } from "../../agency/store/provision-list.slice";
import LoadingForm from "../../shared-components/loading-form/LoadingForm";
import PageHeader from "../../shared-components/page-header/PageHeader";
import AgentProvisionSearchPanel from "../../agency/components/search-panel/AgentProvisionSearchPanel";
import AgentProvisionTable from "../../agency/components/agent-table/AgentProvisionTable";

export interface ProvisionListType {
  currencyResponse: {
    id: string;
    isoCode: string;
    name: string;
    symbol: string;
  };
}

const AgencyReportsProvisionList = (prop: ProvisionListType) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { params }: any = useRouteMatch();

  const agentLoading = useSelector(
    (state: AppState) => state.agents.agent.loading
  );

  const { provisionList, loading } = useSelector(
    (state: AppState) => state.agents.provisionsList
  );

  const filtersProvision = useSelector(
    (state: AppState) => state.agents.filterProvision
  );

  const account = useSelector((state: AppState) => state.account.account);

  const currentAccount = account?.account;
  const balance = currentAccount?.balanceResponse?.[0];

  useEffect(() => {
    if (!currentAccount?.id || !params.currencyId) {
      return;
    }

    dispatch(clearFilterProvisions());

    dispatch(
      filterProvisions(currentAccount.id, {
        ...filtersProvision,
        currencyId: params.currencyId,
      })
    );

    dispatch(
      fetchAllProvisions(currentAccount.id, {
        currencyId: params.currencyId,
      })
    );
  }, [dispatch, currentAccount?.id, params.currencyId]);

  if (agentLoading || !currentAccount) {
    return <LoadingForm />;
  }

  return (
    <div>
      <PageHeader
        title={`${t(
          "app.main.agency.edit.provision.title1",
          "Provision"
        )} - ${balance?.currencyResponse?.isoCode ?? ""} ${
          currentAccount.fullName ?? ""
        }`}
        desc={t(
          "app.main.agency.edit.provision.desc",
          "History of provision transactions"
        )}
        backButton={() => {
          history.push("/agency-reports");
        }}
      />

      <AgentProvisionSearchPanel />

      <AgentProvisionTable data={provisionList} loading={loading} />
    </div>
  );
};

export default AgencyReportsProvisionList;